import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { sendPurchaseOperationData } from "../../../apis/apis.logistics/apisProduct";
import { Link, useNavigate } from "react-router-dom";
export function ReviewOrderPurchaseList({
  order,
  setOrder,
  initialOrderState,
}) {
  const sendPurchase = async () => {
    try {
      const response = await sendPurchaseOperationData(order);
      return response;
    } catch (error) {
      throw error;
    }
  };
  const navigate = useNavigate();
  
  return (
    <>
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden mb-6">
        {/* Desktop View - Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-900 text-gray-100">
              <tr>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">SKU</th>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">PRODUCTO</th>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">UNIDAD</th>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">CANTIDAD ORDENADA</th>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">CANTIDAD FALTANTE</th>
                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">CANTIDAD COMPRADA</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
              {order.operationItems.map((item, index) => {
                const missingQty = Number(item.quantityOrdered) - Number(item.quantityReceived) - Number(item.quantity);
                return (
                  <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{item.sku}</td>
                    <td className="px-4 py-3 text-left text-gray-900 dark:text-white">{item.productName}</td>
                    <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400">{item.unitName}</td>
                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{item.quantityOrdered}</td>
                    <td className="px-4 py-3 text-center">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${missingQty > 0 ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'}`}>
                        {missingQty}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{Number(item.quantityReceived)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Mobile View - Cards */}
        <div className="md:hidden">
          {order.operationItems.map((item, index) => {
            const missingQty = Number(item.quantityOrdered) - Number(item.quantityReceived) - Number(item.quantity);
            return (
              <div key={index} className="p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h4 className="font-semibold text-gray-900 dark:text-white">{item.productName}</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400">SKU: {item.sku} • {item.unitName}</p>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-3 text-sm">
                  <div>
                    <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cant. Ordenada</p>
                    <p className="font-medium text-gray-900 dark:text-white">{item.quantityOrdered}</p>
                  </div>
                  <div>
                    <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cant. Faltante</p>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${missingQty > 0 ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'}`}>
                      {missingQty}
                    </span>
                  </div>
                  <div>
                    <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cant. Comprada</p>
                    <p className="font-medium text-gray-900 dark:text-white">{Number(item.quantityReceived)}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-wrap gap-3">
        <Link
          to='/buys/new_purchase_order'
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
        >
          <i className="fas fa-plus"></i>
          Nuevo
        </Link>
        <Link
          to='/buys/purchase_orders_issued'
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
        >
          <i className="fas fa-list"></i>
          Orden de Compras
        </Link>
      </div>
    </>
  );
}
